module.exports = __webpack_public_path__ + "static/media/icon_filtro.36295729.svg";